import { render } from "./WeekClass.vue?vue&type=template&id=73b0c5c8&scoped=true"
import script from "./WeekClass.vue?vue&type=script&lang=js"
export * from "./WeekClass.vue?vue&type=script&lang=js"

import "./WeekClass.vue?vue&type=style&index=0&id=73b0c5c8&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b0c5c8"]])

export default __exports__